const rotateCircleRadius = 6;

let flipX = false;

export default function LateralAnnotationBoxRotationHandles({
  points,
  onMouseDown,
}){

  let circleOne = {
    cx:0.5 * (points[1][0] + points[2][0]),
    cy:0.5 * (points[1][1] + points[2][1])
  }

  let circlePoint2 = {
    cx:0.5 * (points[0][0] + points[3][0]),
    cy:0.5 * (points[0][1] + points[3][1]),
  }

  if( flipX ){

    circleOne.cx = 1 - circleOne.cx;
    circlePoint2.cx = 1 - circlePoint2.cx;
  }


  let rotationCircles = [
    <g style={{
      //transform:'scaleX(-1)',
    }}>
      <circle style={{cursor:'pointer'}} onMouseDown={e => {
        onMouseDown('rotate1')(e)
        e.stopPropagation();

      }} 
        cx={circleOne.cx} 
        cy={circleOne.cy} 

        opacity={0.8}
        fill={"orange"} r={rotateCircleRadius}/>,



        <circle style={{cursor:'pointer'}} onMouseDown={e => {
          onMouseDown('rotate0')(e);
          e.stopPropagation();
        }} 

          cx={circlePoint2.cx}
          cy={circlePoint2.cy} 
          opacity={0.8}
          fill={"orange"} r={rotateCircleRadius}/>,

          <text style={{
            //transform:'scale(-1,1) translate

          }} key={Math.random()} pointerEvents={"none"} fontSize={9} textAnchor={"middle"} dominantBaseline={"middle"} x={circlePoint2.cx} y={circlePoint2.cy} fontWeight={"bold"}>
            L
          </text>,

          <text key={Math.random()} pointerEvents={"none"} fontWeight={"bold"} fontSize={9} textAnchor={"middle"} dominantBaseline={"middle"} x={circleOne.cx} y={circleOne.cy}>
            R
          </text>
    </g>
    ]
  return rotationCircles;
}
